angular.module('cfn').directive('cfnImportSoilHistoryTab', [
  '$rootScope',
  '$http',
  '$log',
  '$timeout',
  '$filter',
  'CfnUpgradeAccountDialogService',
  function(
    $rootScope,
    $http,
    $log,
    $timeout,
    $filter,
    CfnUpgradeAccountDialogService
  ) {
    return {
      restrict: 'E',
      scope: { ctrl: '=' },
      templateUrl: require('./cfn-import-soil-history-tab.tpl.html'),
      link: function(scope, element, attr) {
        //scope is same as parents scope
        $log.debug(scope.ctrl);
        scope.ctrl.geoServerUrl = $rootScope.credentials.geoserverURL;
        scope.ctrl.showAllianzLogo = false;

        ang.overrideFunction(scope.ctrl, 'onShowTab', function(
          oldShowTab,
          tab
        ) {
          oldShowTab(tab);

          if (
            tab == 'soilHistoryTab' &&
            scope.ctrl.soilHistoryTabUnauthorized
          ) {
            CfnUpgradeAccountDialogService.showDialog();
            return;
          }

          if (tab == 'soilHistoryTab') {
            var geometries = [];
            $timeout(function() {
              //$('#soilSampleDetails').mapwidget('drawFeature', scope.ctrl.details.field.geometry,scope.ctrl.details.field.id,'#fff');
              geometries.push(scope.ctrl.details.field.geometry);
              $('#soilSampleDetails').mapwidget(
                'zoomToGeometriesExtent',
                geometries
              );
            }, 0);
            scope.ctrl.layers = $('#soilSampleDetails').mapwidget('getLayers');

            //Applying roles (service actions) to Biomassekarte
            $.each(scope.ctrl.layers, function(k, v) {
              if (v.name === 'Biomassekarte' || v.name === 'Bio mass map') {
                scope.ctrl.bioMasseKarteDisabled = $filter(
                  'nonauthorizedAction'
                )('soilHistory.layer.bioMassMap');
              }
            });
          }
          $rootScope.window.forceResize();
        });

        ang.overrideFunction(scope.ctrl, 'onShowDetails', function(
          oldShowDetails
        ) {
          oldShowDetails();

          //decide if Bodegedächntis is available for current account type
          scope.ctrl.soilHistoryTabUnauthorized = $filter(
            'nonauthorizedAction'
          )('coreTabs.field.soilHistoryTab');

          if (
            scope.ctrl.details.field &&
            scope.ctrl.details.field.geometry != null &&
            scope.ctrl.details.field.geometry != undefined
          ) {
            var geometries = [];
            geometries.push(scope.ctrl.details.field.geometry);
            $('#soilSampleDetails').mapwidget(
              'zoomToGeometriesExtent',
              geometries
            );
          }
          //TODO Böser Hack für Biomassekarten für die Messe (Bitte lösch mich nach der Messe!!!!!!!!!!)
          if ($('#currentSelected').text() === 'Biomassekarte') {
            $('#soilSampleDetails').mapwidget(
              'showBiomasseMockforField',
              scope.ctrl.details.field.number
            );
          }
          if (scope.ctrl.layers) {
            $.each(scope.ctrl.layers, function(k, v) {
              if (scope.ctrl.layers[k].selected === true) {
                //	            				 var filters = {
                //	                    		         geofilter : [
                //	                    		              {
                //	                    		                 layerId : scope.ctrl.layers[k].id, //Die LayerId, die du über getLayers gezogen hast
                //	                    		                 filterlist: [{
                //	                    		                        operator: 'Equal',
                //	                    		                        filterkey: 'fieldid',
                //	                    		                        filtervalues: [scope.ctrl.details.field.id]
                //	                    		                 }]
                //	                    		              }
                //	                    		         ]
                //	                    		};
                $('#soilSampleDetails').mapwidget(
                  'setFilter',
                  setFilter(
                    scope.ctrl.layers[k].id,
                    scope.ctrl.details.field.id
                  )
                );
              }
            });
          }
        });

        scope.ctrl.onLayerSelect = function(e) {
          if (
            (e.name == 'Biomassekarte' || e.name === 'Bio mass map') &&
            scope.ctrl.bioMasseKarteDisabled
          ) {
            CfnUpgradeAccountDialogService.showDialog();
            return;
          }

          $.each(scope.ctrl.layers, function(k, v) {
            scope.ctrl.layers[k].selected = false;
            $('#soilSampleDetails').mapwidget('hideLayer', v.id);
            if (v.name == e.name) scope.ctrl.layers[k].selected = true;
          });
          //            		 var filters = {
          //            		         geofilter : [
          //            		              {
          //            		                 layerId : e.id, //Die LayerId, die du über getLayers gezogen hast
          //            		                 filterlist: [{
          //            		                        operator: 'Equal',
          //            		                        filterkey: 'fieldid',
          //            		                        filtervalues: [scope.ctrl.details.field.id]
          //            		                 }]
          //            		              }
          //            		         ]
          //            		};

          $('#soilSampleDetails').mapwidget(
            'setFilter',
            setFilter(e.id, scope.ctrl.details.field.id)
          );
          //TODO Böser Hack für Biomassekarten für die Messe (Bitte lösch mich nach der Messe!!!!!!!!!!)
          if (e.name === 'Biomassekarte' || e.name == 'Bio mass map') {
            $('#soilSampleDetails').mapwidget(
              'showBiomasseMockforField',
              scope.ctrl.details.field.number
            );
            scope.ctrl.imageUrl = '';
            scope.ctrl.showAllianzLogo = true;
          } else {
            $('#soilSampleDetails').mapwidget('showLayer', e.id);
            scope.ctrl.imageUrl = $('#soilSampleDetails').mapwidget(
              'getLegend',
              e.id
            );
            scope.ctrl.showAllianzLogo = false;
          }
          $('.jqxExpander').jqxExpander('collapse');
          $('#currentSelected').text(e.name);
        };
      }
    };
  }
]);

function setFilter(layerId, fieldId) {
  var filters = {
    geofilter: [
      {
        layerId: layerId,
        filterlist: [
          {
            operator: 'Equal',
            filterkey: 'fieldid',
            filtervalues: [fieldId]
          }
        ]
      }
    ]
  };
  return filters;
}
